import { Plan, MedicalPlan } from "../constants/aquafina";
import {
  PolicyVariants,
  DENTAL_VARIANT_PLAN_TYPE_MAPPING,
  NOT_OFFERED,
} from "../constants";

function OutOfNetworkDefaultValue<T>(
  oon: T | null,
  fundingType: string | null,
) {
  if (oon === null && fundingType === "Self Funded – ASO") {
    return NOT_OFFERED;
  }
  return null;
}

function RangeIterator<T>(length: number, callback: (index: number) => T): T[] {
  return Array.from({ length }).map((_, index) => callback(index));
}

function ListPlanNames(
  plans: (Plan | MedicalPlan)[],
  coverageType: string,
  variant: PolicyVariants,
): string[] {
  if (coverageType === "medical") {
    return (plans as MedicalPlan[]).map((plan) => plan.basics.name);
  }
  if (coverageType === "dental") {
    const planType =
      DENTAL_VARIANT_PLAN_TYPE_MAPPING[
        variant as keyof typeof DENTAL_VARIANT_PLAN_TYPE_MAPPING
      ];
    const filteredPlans = plans.filter(
      (p): p is Plan => p.planType === planType,
    );
    return filteredPlans.map((plan) => plan.planName);
  }
  return (plans as Plan[]).map((plan) => plan.planName);
}

function FormatDate(dateString: string) {
  if (!dateString) {
    return null;
  }

  let date: Date;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const [year, month, day] = dateString.split("-");
    date = new Date(+year, +month - 1, +day);
  } else {
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) {
    return "invalid date format";
  }

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
}

export { OutOfNetworkDefaultValue, RangeIterator, ListPlanNames, FormatDate };
